import React, { Component } from 'react';
import { Input, Tree } from 'antd';
import { connect } from 'dva';
import style from './index.less';

const { Search } = Input;
const { TreeNode } = Tree;

const labelIcon = 'https://s.xiaoyuanhao.com/images/micro/ejfz_n.svg';
const fzIcon = 'https://s.xiaoyuanhao.com/images/micro/bqfz_n.svg';

@connect(({ labelSetting, user }) => {
  return {
    currentUser: user.currentUser,
    ...labelSetting,
  };
})
class GroupTree extends Component {
  onSelect = selectedKeys => {
    const { onGroupTreeChange } = this.props;
    if (selectedKeys.length !== 0) {
      onGroupTreeChange(selectedKeys)
    }

  };

  render() {

    const { allGroupList } = this.props;

    return (
      <div className={style['group-tree']}>
        <Tree
          blockNode
          showIcon
          defaultExpandAll
          autoExpandParent
          defaultSelectedKeys={['group']}
          onSelect={this.onSelect}
        >
          <TreeNode
            title="标签分组"
            key="group"
            icon={<img src={fzIcon} style={{ marginRight: 6 }} alt="" />}
          >
            {
              allGroupList.map(item => {
                return <TreeNode
                  icon={<img src={labelIcon} alt="" />}
                  title={item.name}
                  key={item.id}
                />
              })
            }
          </TreeNode>
        </Tree>
      </div>
    );
  }
}
export default GroupTree;
